<template>
  <div class="footer">
    <div></div>
    <div></div>
    <div style="cursor: pointer;" @click="goICP">
      <img src="../assets/icp.png" />
      浙ICP备20006231号-1
    </div>
    <div>
      Copyrights © 2021 All Rights Reserved by Tongyou Chat
    </div>
    <div>
      联系我们：0571-88687921
    </div>
    <div>
      联系邮箱：register@2uchat.cn
    </div>
    <div></div>
    <div></div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    goICP() {
      window.open("http://beian.miit.gov.cn");
    }
  }
};
</script>

<style lang="scss">
.footer {
  position: relative;
  height: 0.33rem;
  line-height: 0.33rem;
  color: #e5e5e5;
  font-size: 0.08rem;
  padding: 0 0.3rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background: #fff;
  img {
    width: 0.1rem;
    height: 0.1rem;
    margin-right: 0.03rem;
  }
  div {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: #757575;
  }
}
</style>
